import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { deepMix } from '@antv/util';
import { extent } from 'd3-array';
import { columnOf, column } from './utils/helper';
import { createGroups } from './utils/order';
/**
 * The SymmetryY transform apply offset for y channels, say to transform
 * them to be symmetry.
 */
export var SymmetryY = function SymmetryY() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$groupBy = options.groupBy,
    groupBy = _options$groupBy === void 0 ? 'x' : _options$groupBy;
  return function (I, mark) {
    var encode = mark.encode;
    var x = encode.x,
      rest = __rest(encode, ["x"]);
    // Extract and create new channels starts with y, such as y, y1.
    var Yn = Object.entries(rest).filter(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        k = _ref2[0];
      return k.startsWith('y');
    }).map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 1),
        k = _ref4[0];
      return [k, columnOf(encode, k)[0]];
    });
    var newYn = Yn.map(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 1),
        k = _ref6[0];
      return [k, new Array(I.length)];
    });
    // Group marks into series by specified keys.
    var groups = createGroups(groupBy, I, mark);
    var MY = new Array(groups.length);
    for (var i = 0; i < groups.length; i++) {
      var _I = groups[i];
      var Y = _I.flatMap(function (i) {
        return Yn.map(function (_ref7) {
          var _ref8 = _slicedToArray(_ref7, 2),
            V = _ref8[1];
          return +V[i];
        });
      });
      var _extent = extent(Y),
        _extent2 = _slicedToArray(_extent, 2),
        minY = _extent2[0],
        maxY = _extent2[1];
      MY[i] = (minY + maxY) / 2;
    }
    var maxMiddleY = Math.max.apply(Math, MY);
    for (var m = 0; m < groups.length; m++) {
      var offset = maxMiddleY - MY[m];
      var _I2 = groups[m];
      var _iterator = _createForOfIteratorHelper(_I2),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _i = _step.value;
          for (var j = 0; j < Yn.length; j++) {
            var _Yn$j = _slicedToArray(Yn[j], 2),
              V = _Yn$j[1];
            var _newYn$j = _slicedToArray(newYn[j], 2),
              newV = _newYn$j[1];
            newV[_i] = +V[_i] + offset;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return [I, deepMix({}, mark, {
      encode: Object.fromEntries(newYn.map(function (_ref9) {
        var _ref10 = _slicedToArray(_ref9, 2),
          k = _ref10[0],
          v = _ref10[1];
        return [k, column(v, columnOf(encode, k)[1])];
      }))
    })];
  };
};
SymmetryY.props = {};